import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { TableHead } from '@mui/material';
import StepperComponent from '../Stepper';
import Checkbox from '@mui/material/Checkbox';
import Action from '../Action';
import PropTypes from 'prop-types';
import moment from 'moment';

import './styles.scss';
import { useContext } from 'react';
import GlobalContext from 'contexts';

const TableComponent = ({
  headers,
  hideHeaders,
  columns,
  rows,
  handleRowClick
}) => {
  const { currentUser, currentProduct } = useContext(GlobalContext);
  const userRole = currentUser.role.name;
  const actionsByProductType = [
    {
      key: 2,
      actions: [
        'info',
        'schedulePickup',
        'undo',
        'scheduleAppointment',
        'measures'
      ],
      actionsRequiredByStatus: {
        המתנה: 'schedulePickup',
        'תיאום איסוף': 'schedulePickup',
        'תיאום מפגשים': 'scheduleAppointment',
        'סיכום גנטי': 'scheduleAppointment',
        'משוב ללקוח': 'scheduleAppointment',
        'ממתין לפגישת משוב': 'scheduleAppointment',
        מדדים: 'measures',
        בתהליך: 'scheduleAppointment',
        'דגימה נפסלה': ''
      }
    },
    {
      key: 1,
      actions: [
        'info',
        'scheduleExaminer',
        'undo',
        'scheduleCoach',
        'scheduleDoctor'
      ],
      actionsRequiredByStatus: {
        המתנה: 'scheduleExaminer',
        'סיכום רפואי': 'scheduleCoach',
        'פגישת משוב': 'scheduleDoctor'
      }
    },
    {
      key: 4,
      actions: [
        'info',
        'scheduleExaminer',
        'undo',
        'scheduleDoctor',
        'medicalSummery'
      ],
      actionsRequiredByStatus: {
        המתנה: 'scheduleExaminer',
        'סיכום רפואי': ['scheduleDoctor', 'medicalSummery'],
        'פגישת משוב': 'medicalSummery',
        הושלם: 'medicalSummery'
      }
    }
  ];

  const getProductType = (cp) => {
    return cp.parentId === 0 ? cp.productId : cp.parentId;
  };

  return (
    <Table aria-label="simple table">
      {!hideHeaders && (
        <TableHead classes={{ root: 'tableHeaderRoot' }}>
          <TableRow>
            {headers?.map((header, index) => (
              <TableCell
                key={index}
                classes={{ root: 'headerCellRoot' }}
                align={'center'}
              >
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
      )}
      <TableBody>
        {rows?.map((row, index) => {
          return (
            <TableRow
              classes={{ root: 'tableBodyRowRoot' }}
              hover
              role="checkbox"
              tabIndex={-1}
              key={index}
              onClick={() => handleRowClick && handleRowClick(row.productId)}
            >
              {columns?.map((column, index) => {
                let value = row?.[column?.name];
                const subField = row?.[column?.name]?.[column?.subField];
                const format = column?.format;
                const width = column?.width;
                const height = column?.height;
                const isIcon = column?.icon;
                if (column?.name === 'status' && !row.isActive) {
                  value = 'מבוטל';
                }
                return (
                  <TableCell
                    style={{ maxWidth: width, height: height }}
                    classes={{ root: 'tableBodyCellRoot' }}
                    key={`${index}-${index}`}
                    align={'right'}
                  >
                    {isIcon && index === columns.length - 1 ? (
                      <div className="wrapper-actions">
                        {column?.actions?.map((action, key) => {
                          if (format === 'actionsRequired') {
                            if (
                              column?.actionsRequired?.[
                                subField ? subField : value
                              ]?.indexOf(action.name) > -1
                            ) {
                              if (
                                row.productStage.name !== 'סיכום רופא' &&
                                (row.clientProduct?.product?.id === 1 ||
                                  row.clientProduct?.product?.parentId === 1 ||
                                  row.clientProduct?.product?.id === 4 ||
                                  row.clientProduct?.product?.parentId === 4) &&
                                action.name === 'pdf' &&
                                row.productStage.type === 'שאלון'
                              )
                                return;
                              if (
                                (row.clientProduct?.product?.id === 1 ||
                                  row.clientProduct?.product?.parentId === 1 ||
                                  row.clientProduct?.product?.id === 4 ||
                                  row.clientProduct?.product?.parentId === 4) &&
                                action.type === 'excel'
                              )
                                return;
                              if (
                                row.productStage.name === 'סיכום רופא' &&
                                currentProduct.statusId < 7 &&
                                action.name === 'pdf'
                              )
                                return;
                              else if (
                                action.name === 'pdf' &&
                                row.productStage.name === 'שאלון רפואי כללי'
                              )
                                return;
                              else if (
                                row.productStage.name === 'מדדים' &&
                                ['Sales', 'Service'].includes(
                                  currentUser.role.name
                                )
                              )
                                return;
                              if (row?.productStage?.name === 'בדיקה גנטית') {
                                if (
                                  currentProduct.statusId <= 17 ||
                                  (currentProduct.statusId > 17 &&
                                    action.name !== 'pdf')
                                )
                                  return;
                                else
                                  return (
                                    <Action
                                      key={key}
                                      icon={action.icon}
                                      handleClick={(e) =>
                                        action.handleClick(row, e)
                                      }
                                      txt={action.label}
                                    ></Action>
                                  );
                              }
                              if (
                                (row.clientProduct.product.parentId === 1 ||
                                  row.clientProduct.product.id === 1) &&
                                action.type === 'excel'
                              )
                                return;
                              if (row?.productStage?.name === 'בדיקת דם') {
                                if (
                                  action.name === 'pdf' ||
                                  action.name === 'excel'
                                )
                                  return;
                                else
                                  return (
                                    <Action
                                      key={key}
                                      icon={
                                        action.isBloodTestAction
                                          ? action.hasBloodTestFile
                                            ? action.icon
                                            : 'w'
                                          : action.icon
                                      }
                                      handleClick={(e) =>
                                        action.handleClick(row, e)
                                      }
                                      txt={action.label}
                                    ></Action>
                                  );
                              } else
                                return (
                                  <Action
                                    key={key}
                                    icon={action.icon}
                                    handleClick={(e) =>
                                      action.handleClick(row, e)
                                    }
                                    txt={action.label}
                                  ></Action>
                                );
                            }
                          } else if (format === 'actionsRequiredByStatus') {
                            if (
                              action?.roles?.indexOf(userRole) < 0 ||
                              ((action.name === 'schedulePickup' ||
                                action.name === 'scheduleExaminer') &&
                                row.agree === 'חדש')
                            )
                              return;
                            if (
                              !actionsByProductType
                                .find((a) => getProductType(row) === a.key)
                                ?.actions.includes(action.name)
                            )
                              return;

                            if (
                              action.name === 'scheduleDoctor' &&
                              getProductType(row) !== 4 &&
                              (row.numberOfAppointments <= 2 ||
                                (row.numberOfAppointments > 2 &&
                                  row.scheduledAppoitments > 2))
                            )
                              return;
                            if (
                              action.name === 'info' ||
                              action.name === 'undo' ||
                              (action.name === 'play' && !row.isActive)
                            )
                              return (
                                <Action
                                  key={key}
                                  icon={action.icon}
                                  handleClick={(e) =>
                                    action.handleClick(row, e)
                                  }
                                  txt={action.label}
                                ></Action>
                              );
                            if (
                              ((row.parentId === 3 ||
                                row.productId === 3 ||
                                ((row.parentId === 2 || row.productId === 2) &&
                                  row.statusId > 17 &&
                                  row.statusId <= 22)) &&
                                action.name === 'measures') ||
                              (action.name === 'activeSample' &&
                                row.statusId === 79)
                            )
                              return (
                                <Action
                                  key={key}
                                  icon={action.icon}
                                  handleClick={(e) =>
                                    action.handleClick(row, e)
                                  }
                                  txt={action.label}
                                ></Action>
                              );
                            else {
                              const index = Object.keys(
                                actionsByProductType.find(
                                  (a) => getProductType(row) === a.key
                                ).actionsRequiredByStatus
                              ).indexOf(row.status);
                              if (index > -1) {
                                const actionValue = Object.values(
                                  actionsByProductType.find(
                                    (a) => getProductType(row) === a.key
                                  ).actionsRequiredByStatus
                                )[index];

                                const shouldRender =
                                  typeof actionValue === 'string'
                                    ? action.name === actionValue
                                    : Array.isArray(actionValue)
                                    ? actionValue.includes(action.name)
                                    : false;

                                if (shouldRender) {
                                  return (
                                    <Action
                                      key={key}
                                      icon={action.icon}
                                      handleClick={(e) =>
                                        action.handleClick(row, e)
                                      }
                                      txt={action.label}
                                    />
                                  );
                                }
                              }
                            }
                          } else {
                            return (
                              <Action
                                key={key}
                                icon={action.icon}
                                handleClick={action.handleClick}
                              ></Action>
                            );
                          }
                        })}
                      </div>
                    ) : format === 'date' ? (
                      <div>{moment(value).format('DD.MM.YYYY')}</div>
                    ) : format === 'stepper' ? (
                      <StepperComponent {...row}></StepperComponent>
                    ) : format === 'price' ? (
                      <div>{`${value} ₪`}</div>
                    ) : format === 'Checkbox' ? (
                      row?.productStage?.type === 'טופס' ||
                      row?.productStage?.name === 'בדיקת דם' ? (
                        <Checkbox
                          checked={value === 'הסתיים' ? true : false}
                          onChange={() => column.handleChange(row)}
                          disabled={value === 'הסתיים' ? true : false}
                        ></Checkbox>
                      ) : (
                        <div></div>
                      )
                    ) : hideHeaders ? (
                      <div className="wrapper-td">
                        {' '}
                        <div className="td-title">{headers[index]}</div>
                        <div className="td-content">
                          {subField || format === 'dateWithHeader'
                            ? moment(value).format('DD.MM.YYYY')
                            : value}
                        </div>
                      </div>
                    ) : (
                      `${subField ? subField : value}`
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default TableComponent;

TableComponent.propTypes = {
  headers: PropTypes.array,
  hideHeaders: PropTypes.bool,
  columns: PropTypes.array,
  rows: PropTypes.array,
  handleRowClick: PropTypes.func
};
